/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Telegram_Not_LinkedInputs */

const he_account_delivery_telegram_not_linked = /** @type {(inputs: Account_Delivery_Telegram_Not_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חברו את חשבון הטלגרם שלכם כדי לקבל התראות שם`)
};

const en_account_delivery_telegram_not_linked = /** @type {(inputs: Account_Delivery_Telegram_Not_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link your Telegram account to receive alerts there`)
};

/**
* | output |
* | --- |
* | "Link your Telegram account to receive alerts there" |
*
* @param {Account_Delivery_Telegram_Not_LinkedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_telegram_not_linked = /** @type {((inputs?: Account_Delivery_Telegram_Not_LinkedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Telegram_Not_LinkedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_telegram_not_linked(inputs)
	return en_account_delivery_telegram_not_linked(inputs)
});